import {AbsWidgetSpacer} from 'scriptable-abstract';

interface WidgetSpacerState {
  length: number;
}

export class MockWidgetSpacer extends AbsWidgetSpacer<WidgetSpacerState> {
  constructor(length?: number) {
    super();
    this.setState({length: length ?? 0});
  }

  get length(): number {
    return this.state.length;
  }

  set length(value: number) {
    this.setState({length: value});
  }
}
